var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "16px",
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/arrow copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.625,9 L3.375,9 C3.16875,9 3,8.83125 3,8.625 L3,7.375 C3,7.16875 3.16875,7 3.375,7 L4.625,7 C4.83125,7 5,7.16875 5,7.375 L5,8.625 C5,8.83125 4.83125,9 4.625,9 Z M8,8.625 L8,7.375 C8,7.16875 7.83125,7 7.625,7 L6.375,7 C6.16875,7 6,7.16875 6,7.375 L6,8.625 C6,8.83125 6.16875,9 6.375,9 L7.625,9 C7.83125,9 8,8.83125 8,8.625 Z M11,8.625 L11,7.375 C11,7.16875 10.83125,7 10.625,7 L9.375,7 C9.16875,7 9,7.16875 9,7.375 L9,8.625 C9,8.83125 9.16875,9 9.375,9 L10.625,9 C10.83125,9 11,8.83125 11,8.625 Z M8,11.625 L8,10.375 C8,10.16875 7.83125,10 7.625,10 L6.375,10 C6.16875,10 6,10.16875 6,10.375 L6,11.625 C6,11.83125 6.16875,12 6.375,12 L7.625,12 C7.83125,12 8,11.83125 8,11.625 Z M5,11.625 L5,10.375 C5,10.16875 4.83125,10 4.625,10 L3.375,10 C3.16875,10 3,10.16875 3,10.375 L3,11.625 C3,11.83125 3.16875,12 3.375,12 L4.625,12 C4.83125,12 5,11.83125 5,11.625 Z M11,11.625 L11,10.375 C11,10.16875 10.83125,10 10.625,10 L9.375,10 C9.16875,10 9,10.16875 9,10.375 L9,11.625 C9,11.83125 9.16875,12 9.375,12 L10.625,12 C10.83125,12 11,11.83125 11,11.625 Z M14,3.5 L14,14.5 C14,15.328125 13.328125,16 12.5,16 L1.5,16 C0.671875,16 0,15.328125 0,14.5 L0,3.5 C0,2.671875 0.671875,2 1.5,2 L3,2 L3,0.375 C3,0.16875 3.16875,0 3.375,0 L4.625,0 C4.83125,0 5,0.16875 5,0.375 L5,2 L9,2 L9,0.375 C9,0.16875 9.16875,0 9.375,0 L10.625,0 C10.83125,0 11,0.16875 11,0.375 L11,2 L12.5,2 C13.328125,2 14,2.671875 14,3.5 Z M12.5,14.3125 L12.5,5 L1.5,5 L1.5,14.3125 C1.5,14.415625 1.584375,14.5 1.6875,14.5 L12.3125,14.5 C12.415625,14.5 12.5,14.415625 12.5,14.3125 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input_field/icon",
    transform: "translate(-11.000000, -12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/calendar",
    transform: "translate(10.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color/eerie_black",
    transform: "translate(1.333333, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/cadet_grey",
    mask: "url(#mask-2)",
    fill: "#9EA8B2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.333333, 0.000000)",
    id: "Rectangle-Copy"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.abf0f657b1d87c7c4b3ff8a2fde546ca.svg";
export { ForwardRef as ReactComponent };